import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { graphql } from 'react-apollo';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import PrecautionNotificationForm from '../../../../components/SiteAdmin/PrecautionNotificationForm/PrecautionNotificationForm';
import Loader from '../../../../components/Common/Loader/Loader';

import getAllPrecautionNotification from './getAllPrecautionNotification.graphql';
import messages from '../../../../locale/messages';

import s from './PrecautionNotificationPage.css';

class PrecautionNotificationPage extends Component {

    static defaultProps = {
        data: { loading: true }
    }

    render() {
        const { data: { loading, getAllPrecautionNotification } } = this.props;
        const { formatMessage } = this.props.intl;
        let initialValues = { isEnabled: 'true' };
        if (!loading && getAllPrecautionNotification && getAllPrecautionNotification.results && getAllPrecautionNotification.results.length > 0) {
            initialValues = getAllPrecautionNotification.results[0];
            initialValues['isEnabled'] = initialValues.isEnabled ? 'true' : 'false';
        }

        return (
            <Loader type={"page"} show={loading}>
                <div className={s.root}>
                    {!loading && <div className={s.container}>
                        <div className={cx(s.heading, 'textAlignRightRTL', 'textWhite')}>
                            {formatMessage(messages.precautionNotification)}
                        </div>
                        <div className={s.paddingRoutesSection}>
                            <PrecautionNotificationForm initialValues={initialValues} />
                        </div>
                    </div>}
                </div>
            </Loader>
        )
    }
}


export default compose(
    injectIntl,
    withStyles(s),
    graphql(getAllPrecautionNotification, {
        options: {
            fetchPolicy: 'network-only',
            ssr: false
        }
    }))(PrecautionNotificationPage)